import Vue from 'vue';
import { mapGetters } from 'vuex';
import { guid } from '@/mixins/guid';

export default Vue.component('forget-device-modal', {
  template: require('./template.html'),
  name: 'forget-device-modal',
  mixins: [guid],
  computed: {
    ...mapGetters(['currentUser', 'userAttributes']),
  },
  data() {
    return {
      loading: false,
      sendErrors: false,
    };
  },
  props: ['toggle-modal', 'modal', 'active-device', 'active-index'],
  methods: {
    async forgetDevice() {
      this.loading = true;
      this.sendErrors = false;
      try {
        await this._SEND([{
          name: 'forgetDevice',
          payload: {
            deviceKey: this.activeDevice.DeviceKey,
          },
        }]);
        this.$emit('remove-device', this.activeIndex);
        this.closeModal('forgetDevice');
        this.$store.dispatch('addNotification', {
          id: this.guid(),
          type: 'success',
          message: 'Device successfully forgotten.',
        });
      } catch (e) {
        this.$log.error(e.message || e);
        this.sendErrors = `${e.message || e}. This has been reported.`;
        await this._reportError({
          error: e,
          fn: 'forgetDevice',
        });
      } finally {
        this.loading = false;
      }
    },
    closeModal(type) {
      this.$emit('toggle-modal', type, 'child');
    },
    formatErrors(arr) {
      return arr.join(' ');
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/account/security/devices/forget-device-modal/index.js